import React from 'react';
import { ERROR_CODE } from '@src/errors/code';
import { useTranslation } from 'react-i18next';
import { CircularProgress, Typography } from '@mui/material';
import CommonButton from '@src/new-components/Button';
import CustomTypography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { StyledRecordAgain } from './index.style';

const Spacer = ({ height = 40 }) => <div style={{ height }} />;

const RecordAgain = ({
  audioError,
  handleReset,
  handleRequestMic,
  isMicPermissionDenied,
  verifyYourVoice,
  loadingVerifyVoice,
  voiceCheckStatus,
}) => {
  const { t } = useTranslation();

  return (
    <StyledRecordAgain>
      {audioError && (
        <Typography
          sx={{ height: 40 }}
          variant="body1"
          color={COLOR.errorDropZone}
          style={{
            textAlign: 'center',
          }}
          dangerouslySetInnerHTML={{
            __html: audioError,
          }}
        />
      )}

      {loadingVerifyVoice && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            justifyContent: 'center',
            height: 40,
          }}
        >
          <CircularProgress size={20} sx={{ color: COLOR.descriptionUpload }} />
          <CustomTypography
            variant="body-14-regular"
            color={COLOR.descriptionUpload}
          >
            {t('checkingVoiceVerification')}
          </CustomTypography>
        </div>
      )}

      {!audioError && !loadingVerifyVoice && <Spacer />}

      <div
        style={{
          display: 'flex',
          gap: 16,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CommonButton
          variant="outlineSmall"
          textProps={{
            variantText: 'body-14-bold',
            color: COLOR.darkBlue,
          }}
          customStyle={{
            width: 'max-content',
            margin: '0 auto',
            padding: '12px 24px',
          }}
          disabled={
            loadingVerifyVoice ||
            voiceCheckStatus === ERROR_CODE.VOICE_ALREADY_VERIFIED
          }
          onClick={isMicPermissionDenied ? handleRequestMic : handleReset}
        >
          {isMicPermissionDenied ? t('tryAgain') : t('recordAgain')}
        </CommonButton>
        {!audioError && (
          <CommonButton
            variant="contained"
            textProps={{
              variantText: 'body-14-bold',
              color: COLOR.darkBlue,
            }}
            customStyle={{
              width: 'max-content',
              margin: '0 auto',
              padding: '12px 24px',
            }}
            onClick={verifyYourVoice}
            disabled={loadingVerifyVoice}
          >
            {t('verifyYourVoice')}
          </CommonButton>
        )}
      </div>
    </StyledRecordAgain>
  );
};

export default RecordAgain;
